import { Config } from '../config/config.es6';

export default class Param {
    constructor() {
        this.ARG = {}; // パラメータのオブジェクト
        this.TODAY = new Date(); // 今日の日付
        this.init();
    }

    init() {
        // パラメータを取得
        this.getParam();

        // パラメータの使用
        if (Config.USE_PARAM) {
            // 今日の日付を変更
            this.changeToday();
        }
    }

    getParam() {
        const param = location.search.substring(1).split('&');

        // 取得したパラメータをオブジェクトに格納
        for (let i = 0; param[i]; i++) {
            let key = param[i].split('=');
            this.ARG[key[0]] = key[1];
        }
    }

    changeToday() {
        if (this.ARG.date) {
            let dateTime = this.ARG.date;
            dateTime += this.ARG.time ? ' ' + this.ARG.time : '';
            this.TODAY = new Date(dateTime);
        }
    }
}
